export default __webpack_public_path__ + "static/media/bg_231140297.717cf13e.webp";